module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-23.e5221405.png";